import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const departmentService = {
  getAll: async (params = {}) => {
    return await axios.get(`${domain}/api/Department`, {
      headers,
      params: params // Pass the feature flags to the backend
    });
  },

  getAllActive: async (params = {}) => {
    return await axios.get(`${domain}/api/Department/active`, {
      headers,
      params: params // Pass the feature flags to the backend
    });
  },

  getEmployeeTypes: async () => {
    return await axios.get(`${domain}/api/EmployeeType`, { headers });
  },

  getDivisions: async () => {
    return await axios.get(`${domain}/api/Division`, { headers });
  },

  create: async (payload) => {
    return await axios.post(`${domain}/api/Department`, payload, { headers });
  },

  update: async (id, payload) => {
    return await axios.put(`${domain}/api/Department/${id}`, payload, { headers });
  },

  delete: async (id) => {
    return await axios.delete(`${domain}/api/Department/${id}`, { headers });
  },
};

export default departmentService;